import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DocumentActions } from './document.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { EmployeeService } from '@core/services/employee.service';
import { TranslateService } from '@ngx-translate/core';
import { AddDocumentPayload } from '@core/interface/employee-document';

@Injectable()
export class DocumentEffects {
  private actions$ = inject(Actions);
  private employeeService = inject(EmployeeService);
  private translateService = inject(TranslateService);

  getDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentActions.loadDocuments),
      mergeMap((data) => {
        return this.employeeService.getDocuments(data).pipe(
          map((documents) =>
            documents.success
              ? DocumentActions.loadDocumentsSuccess(documents)
              : DocumentActions.loadDocumentsFailure(documents)
          ),
          catchError((error) =>
            of(
              DocumentActions.loadDocumentsFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        );
      })
    )
  );

  deleteDocument$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentActions.deleteDocument),
      mergeMap((data) =>
        this.employeeService.deleteDocument(data.id).pipe(
          map((response: any) =>
            response.success
              ? DocumentActions.deleteDocumentSuccess({
                  ...response,
                  id: data.id,
                })
              : DocumentActions.deleteDocumentFailure(response)
          ),
          catchError((error) =>
            of(
              DocumentActions.deleteDocumentFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
